import { render, staticRenderFns } from "./FlavourBoosterList.vue?vue&type=template&id=c2430d52&"
import script from "./FlavourBoosterList.vue?vue&type=script&lang=js&"
export * from "./FlavourBoosterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports